// extracted by mini-css-extract-plugin
module.exports = {"w1nr0b8d":"w1nr0b8d"};